import { app } from '@/main'
import * as dayjs from 'dayjs'
import Sentry from '@/3rd-parties/sentry'
import { logger } from '@ahaslides-product/frontend-toolkit'

// mutations
import audienceId from '@/store/mutations/audienceId'
import slideOptions from '@/store/mutations/slideOptions'
import slides from '@/store/mutations/slides'
import currentUser from '@/store/mutations/currentUser'
import presentation from '@/store/mutations/presentation'
import attendedPresentation from '@/store/mutations/attendedPresentation'

const logFn = logger.extend('slideMutation')

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...currentUser,
  ...presentation,
  ...attendedPresentation,

  setLang: (state, payload) => {
    // code br cũ đang sai đã update presenter thành pt, để các presentation cũ vẫn hoạt động cần switch br thành pt
    // TODO: xoá logic này khi code br được thêm vào lại (nếu có)
    if (payload === 'br') {
      payload = 'pt'
    }
    app.$i18n.locale = payload
    dayjs.locale(payload)
  },

  setSlide: (state, payload) => {
    if (state.slide.id !== payload.id) {
      state.slide = payload
    }
  },

  updateSlide: (state, payload) => {
    // updateSlide is an in-place field merge on the ACTIVE slide; slide identity
    // only ever changes via setSlide. Drop any payload whose id targets a
    // different slide so a stale/cross-slide update can't overwrite the active
    // slide id (which would snap the audience to the wrong slide).
    if (payload && payload.id != null && state.slide.id != null && payload.id !== state.slide.id) {
      logFn('updateSlide: drop cross-slide payload', null, {
        incomingSlideId: payload.id,
        activeSlideId: state.slide.id,
      })
      return
    }
    if (state.slide.quizStatus === 4 && payload.quizStatus === 1 && state.slide.id === payload.id) {
      // Diagnostic probe (added 2025-06-24) observing whether this transition happens —
      // it does, ~982/day, and the update is applied regardless, so it is not a fault.
      Sentry.warn('slide.mutation:updateQuizStatus from question screen to lobby screen', {
        currentSlide: state.slide,
        updatedSlide: payload,
      })
    }
    state.slide = { ...state.slide, ...payload }
  },

  setPresentation: (state, payload) => {
    state.presentation.id = null
    state.presentation = payload
  },

  patchPresentation: (state, payload) => {
    state.presentation = { ...state.presentation, ...payload }
  },

  setConnectionError: (state, payload) => {
    state.connectionError = payload
  },

  setUserLoaded: (state, payload) => {
    state.userLoaded = payload
  },

  setIsLoadingCurrentUser: (state, payload) => {
    state.isLoadingCurrentUser = payload
  },
}
